import { format } from 'date-fns';

import stringHelper from '../../../../utils/stringHelper';

import type { ValueOf } from 'type-fest';

// Constants
export const TENANT_STATES = {
  CURRENT: 'current',
  UPCOMING: 'upcoming',
  EXPIRED: 'expired',
} as const;

export const TAG_TONES = {
  [TENANT_STATES.CURRENT]: 'blue',
  [TENANT_STATES.UPCOMING]: 'purple',
  [TENANT_STATES.EXPIRED]: 'orange',
} as const;

export const DEFAULT_TAG_TONE = 'gray';

// Types
export type TenantState = ValueOf<typeof TENANT_STATES>;

// Utility functions
export const getTagTone = (state: string): 'blue' | 'purple' | 'orange' | 'gray' => {
  const normalizedState = state.toLowerCase() as TenantState;
  return (TAG_TONES[normalizedState] || DEFAULT_TAG_TONE) as 'blue' | 'purple' | 'orange' | 'gray';
};

export const getTenantState = (state: string) => {
  return `${stringHelper.sentenceCase(state)} tenant`;
};

export const getTenantStateTag = (state: string) => {
  return stringHelper.sentenceCase(state);
};

export const getValueOrDash = (value: string | number | undefined): string => {
  return value?.toString() || '-';
};

export const formatDate = (dateMs: number): string => {
  return format(new Date(dateMs), 'MMMM d, yyyy');
};
